/* Bury Me In Rags theme.js — variant selection + AJAX cart */
(function () {
  /* ---- variant selection on PDP ---- */
  var form = document.querySelector('[data-product-form]');
  var productData = null;
  var dataEl = document.querySelector('[data-product-json]');
  if (dataEl) {
    try { productData = JSON.parse(dataEl.textContent); } catch (e) { productData = null; }
  }
  var variantInput = document.querySelector('[data-variant-id]');
  var selects = document.querySelectorAll('[data-option-select]');
  var addBtn = document.querySelector('[data-add-btn]');

  if (form && productData && variantInput) {
    function findVariant() {
      var opts = [];
      selects.forEach(function (sel) {
        opts[parseInt(sel.getAttribute('data-option-index'), 10)] = sel.value;
      });
      var variants = productData.variants || [];
      for (var i = 0; i < variants.length; i++) {
        var match = true;
        for (var j = 0; j < opts.length; j++) {
          if (variants[i].options[j] !== opts[j]) { match = false; break; }
        }
        if (match) return variants[i];
      }
      return null;
    }
    function update() {
      var v = findVariant();
      if (!v) return;
      variantInput.value = v.id;
      if (addBtn) {
        if (v.available) { addBtn.disabled = false; addBtn.textContent = 'ADD TO CART'; }
        else { addBtn.disabled = true; addBtn.textContent = 'SOLD OUT'; }
      }
      var img = document.getElementById('pdp-image');
      if (v.featured_image && img && v.featured_image.src) { img.src = v.featured_image.src; }
    }
    selects.forEach(function (sel) { sel.addEventListener('change', update); });
    update();
  }

  /* ---- AJAX add to cart (progressive enhancement) ---- */
  if (form && window.routes && window.routes.cart_add_url) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add-btn]');
      var data = new FormData(form);
      fetch(window.routes.cart_add_url + '.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function () { return fetch(window.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
          if (btn) { var orig = btn.textContent; btn.textContent = '✓ ADDED'; setTimeout(function () { btn.textContent = orig; }, 1500); }
        })
        .catch(function () { form.submit(); });
    });
  }
})();

/* ---- Front page: keep the three columns in even rows ----
   Every photo sits in the same square box, and row 1 of each column lines up
   with row 1 of the others, row 2 with row 2, and so on. It re-runs on its own
   when photos load, items are added or filtered, or the screen size changes. */
(function () {
  var wrap = document.querySelector('.bmir-columns');
  if (!wrap) return;
  var css = document.createElement('style');
  css.textContent =
    '.bmir-columns .bmir-item{box-sizing:border-box}' +
    '.bmir-columns .bmir-item-media{display:block}' +
    '.bmir-columns .bmir-item-media .bmir-item-image{aspect-ratio:1/1;height:auto;object-fit:contain;background:#fff}' +
    '.bmir-columns .bmir-flip-inner{aspect-ratio:1/1}';
  document.head.appendChild(css);

  var cols = [].slice.call(wrap.children).filter(function (c) { return c.classList.contains('bmir-column'); });
  var pending = 0;
  function items(col) {
    return [].slice.call(col.children).filter(function (el) {
      return el.classList.contains('bmir-item') && el.offsetParent !== null;
    });
  }
  function align() {
    pending = 0;
    var lists = cols.map(items);
    lists.forEach(function (l) { l.forEach(function (el) { el.style.minHeight = ''; el.style.marginTop = ''; }); });
    if (cols.length < 2 || wrap.classList.contains('is-filtered')) return;
    var tops = lists.map(function (l) { return l[0] ? l[0].getBoundingClientRect().top : null; });
    var known = tops.filter(function (t) { return t !== null; });
    if (!known.length) return;
    var maxTop = Math.max.apply(null, known);
    lists.forEach(function (l, i) {
      if (l[0] && maxTop - tops[i] > 0.5) l[0].style.marginTop = (maxTop - tops[i]) + 'px';
    });
    var rows = Math.max.apply(null, lists.map(function (l) { return l.length; }));
    for (var r = 0; r < rows; r++) {
      var row = lists.map(function (l) { return l[r]; }).filter(Boolean);
      var h = Math.max.apply(null, row.map(function (el) { return el.getBoundingClientRect().height; }));
      row.forEach(function (el) { el.style.minHeight = h + 'px'; });
    }
  }
  function queue() { if (!pending) pending = requestAnimationFrame(align); }
  queue();
  window.addEventListener('load', queue);
  window.addEventListener('resize', queue);
  wrap.addEventListener('load', queue, true);
  wrap.addEventListener('loadedmetadata', queue, true);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);
  if ('MutationObserver' in window) {
    new MutationObserver(queue).observe(wrap, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden'] });
  }
})();
